<template lang="html">
  <div>
    <div :style="embedContainerPadding" class="embed-container">
      <iframe
        ref="playerFrame"
        :src="previewLink"
        frameborder="0"
        webkitAllowFullScreen
        mozallowfullscreen
        allowFullScreen
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "LivePreviewNoAudio",
  data() {
    return {};
  },
  computed: {
    id() {
      return this.$store.state.show.currentShowKey;
    },
    previewLink() {
      if (process.env.NODE_ENV === "development") {
        console.log("Using Stage preview link during development.");
        return `https://soundslides-stage.firebaseapp.com/app/editor/${
          this.id
        }/preview-only/fill`;
      }
      return `/app/editor/${this.id}/preview-only/fill`;
    },
    displaySettings() {
      return this.$store.state.show.currentShow.data.displaySettings;
    },
    embedContainerPadding() {
      var padding = 100 / this.displaySettings.aspectRatio || 66.63;
      return {
        "padding-bottom": padding + "%"
      };
    }
  },
  watch: {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.embed-container {
  position: relative;
  padding-bottom: 66.63%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
